<template>
    <template v-if="audioStore.isRecording">
        <div class="flex w-full items-center gap-3 flex-1">
            <IconButton
                aria-label="Cancelar gravação"
                class="ic-btn-ghost-primary w-6 h-6 cursor-pointer rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                @click="audioStore.stopRecorder"
            >
                <XMarkIcon class="h-6 w-6 text-gray-700 dark:text-white"/>
            </IconButton>

            <div class="flex items-center gap-2 flex-1">
                <div class="relative flex items-center justify-center">
                    <span
                        class="animate-ping absolute inline-flex h-2.5 w-2.5 rounded-full bg-red-500 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-600"></span>
                </div>
                <span class="font-mono text-sm text-gray-600 dark:text-gray-400 select-none">
                    {{ audioStore.recordedTime }}
                </span>
            </div>
            <IconButton
                aria-label="Enviar áudio"
                class="ic-btn-ghost-primary w-6 h-6 cursor-pointer rounded-full bg-indigo-500 hover:bg-indigo-300 dark:hover:bg-indigo-800 transition-colors active:scale-95"
                @click="sendAudio"
            >
                <CheckIcon class="w-5 h-5 text-white"/>
            </IconButton>
        </div>
    </template>
</template>

<script lang="ts" setup>
import {onMounted, watch} from "vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import {useAudioStore} from "@src/stores/audio";
import {CheckIcon, XMarkIcon} from "@heroicons/vue/24/outline";
import IconButton from "@src/components/ui/inputs/IconButton.vue";
import {useMessageStore} from "@src/stores/messages";

const audioStore = useAudioStore()
const sessionStore = useChatSessionStore()
const messageStore = useMessageStore()

onMounted(() => {
    if (sessionStore.selectedSession?.channel?.type === 'instagram') {
        audioStore.format = 'mp4'
    }
})

async function sendAudio() {
    try {
        const record = await audioStore.recorder?.stop()
        audioStore.stopRecorder()

        const audioFile = new File(
            [record?.blob ?? new Blob()],
            `audio-${Date.now()}.${audioStore.format}`,
            {type: record?.blob?.type}
        )

        await messageStore.submitMedia([audioFile], 'audio', ['mp3'])
    } catch (e) {
        console.error(e)
        setTimeout(() => audioStore.stopRecorder(), 100)
    }
}

watch(() => sessionStore.selectedSession, (val: any) => {
    if (val?.channel?.type === 'instagram') {
        audioStore.format = 'mp4'
    } else {
        audioStore.format = 'mp3'
    }
})
</script>

<style scoped>
@keyframes ping {
    75%, 100% {
        transform: scale(2);
        opacity: 0;
    }
}
</style>